import React from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import styles from './index.module.scss'

export default function SuggestionsFound({ suggestionsAmount, showSuggestions, setShowSuggestions }) {
  if (suggestionsAmount === 0) {
    return null
  }

  const handleClick = () => {
    setShowSuggestions(!showSuggestions)
  }

  return (
    <div className={styles.suggestionsFound}>
      <Tag onClick={handleClick}>
        <div className={styles.suggestionsFoundText}>
          {suggestionsAmount} pre-approved template{suggestionsAmount !== 1 ? 's' : ''} found {showSuggestions ? <UpOutlined /> : <DownOutlined />}
        </div>
      </Tag>
    </div>
  )
}
